import $foreign from "./foreign.cjs";
var toExponentialNative = $foreign.toExponentialNative;
var toFixedNative = $foreign.toFixedNative;
var toPrecisionNative = $foreign.toPrecisionNative;
var toString = $foreign.toString;
export { toExponentialNative, toFixedNative, toPrecisionNative, toString };
